import { useEffect, useState } from "react";
import { Download } from "lucide-react";

export const InstallPWA = () => {
  const [prompt, setPrompt] = useState(null);
  const [hidden, setHidden] = useState(false);

  useEffect(() => {
    const onBeforeInstall = (e) => {
      e.preventDefault();
      setPrompt(e);
    };
    const onInstalled = () => {
      setPrompt(null);
      setHidden(true);
    };
    window.addEventListener("beforeinstallprompt", onBeforeInstall);
    window.addEventListener("appinstalled", onInstalled);
    return () => {
      window.removeEventListener("beforeinstallprompt", onBeforeInstall);
      window.removeEventListener("appinstalled", onInstalled);
    };
  }, []);

  const install = async () => {
    if (!prompt) return;
    prompt.prompt();
    const { outcome } = await prompt.userChoice;
    if (outcome === "accepted") setHidden(true);
    setPrompt(null);
  };

  if (!prompt || hidden) return null;

  return (
    <button
      data-testid="install-pwa-btn"
      onClick={install}
      title="Install Lectura"
      className="hidden sm:flex items-center gap-1.5 px-3 py-2 rounded-full border border-primary/40 text-sm font-semibold text-primary hover:bg-primary/10 transition"
    >
      <Download className="h-4 w-4" /> Install
    </button>
  );
};
